import { useApp } from "@/stores/app";

import App from '@/App.vue';

import router from '@/router';
import routerGuard from '@/router/guard.ts';
import i18n from '@/i18n';

import '@/main.css';
import 'vue-sonner/style.css';

const app = createApp(App);
const pinia = createPinia();

app.use(i18n);
app.use(pinia);

const appStore = useApp();

(async () => {
    await appStore.init();

    app.use(routerGuard);
    app.use(router);

    await router.isReady();

    app.mount('#app');
})();